/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message, Steps} from 'antd'
import moment from 'moment'
import {Link} from 'react-router-dom'
import Select from 'react-select'
import jMoment from 'moment-jalaali'

import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SECURITY from '../BaseComponent/SECURITY'
import InputMask from 'react-input-mask'
const Step = Steps.Step

class AddUser extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      current: 0,
      error: '',
      catArr: [],
      roles: [],
      filterRoles: [],
      Cities: [],
      selectedDate: moment(),
      cats: [],
      selectedOption: [],
      rolesArr: [],
      userCode: null,
      roleCategory: '',
      username: '',
      password: '',
      firstname: '',
      lastname: '',
      mobile: '',
      nationalId: '',
      gender: 'man',
      email: '',
      phone: '',
      father: '',
      cityId: '',
      zipCode: '',
      address: '',
      birthday: '',
      internalNumber: ''
    }
  }

  componentDidMount() {
    http.get(`${SECURITY.SECURITY_MANAGE_LIST_ROLECATEGORY}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          cats: response.data.object
        })
      } else {
        // message.error(response.data.description)
      }
    })

    http
      .get(`base/report/city?export=true`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            Cities: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  next() {
    if (this.state.current == '0') {
      var {roleCategory, rolesArr, username, password} = this.state
      var roleCatError = false
      var roleIdError = false
      var passError = false
      var usernameError = false
      var firstSectionError = false
      if (roleCategory == '') {
        roleCatError = true
        firstSectionError = true
        message.error('گروه نقش را وارد کنید')
      } else {
        if (!roleCatError) {
          this.setState({error: ''})
        }
      }
      if (rolesArr.length == '0') {
        roleIdError = true
        firstSectionError = true
        message.error('نقش را تعیین کنید')
      } else {
        if (!roleIdError) {
          this.setState({
            error: ''
          })
        }
      }

      if (username == '') {
        usernameError = true
        firstSectionError = true
        message.error('نام کاربری را وارد کنید')
      } else if (username.length < 6) {
        usernameError = true
        firstSectionError = true
        message.error('نام کاربری باید حداقل 6 کاراکتر باشد')
      } else {
        if (!usernameError) {
          this.setState({
            error: ''
          })
        }
      }

      if (password == '') {
        passError = true
        firstSectionError = true
        message.error('کلمه عبور را وارد کنید')
      } else if (password.length < 6) {
        passError = true
        firstSectionError = true
        message.error('کلمه عبور باید حداقل 6 کاراکتر باشد')
      } else {
        if (!passError) {
          this.setState({
            error: ''
          })
        }
      }

      if (!firstSectionError) {
        const current = this.state.current + 1
        this.setState({current})
      }
    } else if (this.state.current == '1') {
      var {firstname, lastname, mobile, nationalId} = this.state
      var firstnameError = false
      var lastnameError = false
      var mobileError = false
      var nationalIdError = false
      var secondSectionError = false

      var sum = 0
      for (var i = 0; i < nationalId.length - 1; i++) {
        sum += nationalId.charAt(i) * (i + 1)
      }
      sum += 1
      var val = sum % 11
      val = Math.abs(val - 1)
      if (!(nationalId.charAt(nationalId.length - 1) == val)) {
        secondSectionError = true
        nationalIdError = true
        message.error('کد ملی وارد شده معتبر نیست')
      } else if (
        nationalId == '0000000000' ||
        nationalId == '1111111111' ||
        nationalId == '2222222222' ||
        nationalId == '3333333333' ||
        nationalId == '4444444444' ||
        nationalId == '5555555555' ||
        nationalId == '6666666666' ||
        nationalId == '7777777777' ||
        nationalId == '8888888888' ||
        nationalId == '9999999999'
      ) {
        secondSectionError = true
        nationalIdError = true
        message.error('کد ملی وارد شده معتبر نیست')
      } else if (nationalId == '') {
        secondSectionError = true
        nationalIdError = true
        message.error('کد ملی را وارد کنید')
      } else {
        if (!nationalIdError) {
          this.setState({error: ''})
        }
      }
      if (firstname == '') {
        firstnameError = true
        secondSectionError = true
        message.error('نام را وارد کنید')
      } else {
        if (!firstnameError) {
          this.setState({
            error: ''
          })
        }
      }
      if (lastname == '') {
        lastnameError = true
        secondSectionError = true
        message.error('نام خانوادگی را وارد کنید')
      } else {
        if (!lastnameError) {
          this.setState({
            error: ''
          })
        }
      }

      if (mobile == '') {
        mobileError = true
        secondSectionError = true
        message.error('موبایل را وارد کنید')
      } else if (!mobile.match(/^09\d{9}$/g)) {
        mobileError = true
        secondSectionError = true
        message.error('موبایل را صحیح وارد کنید.مثال : 09124444444')
      } else {
        if (!mobileError) {
          this.setState({
            error: ''
          })
        }
      }

      // if (zipCode == '') {
      //     zipCodeError = true;
      //     secondSectionError = true;
      //     message.error('کد پستی وارد کنید')
      // } else if (!zipCode.match(/^\d{10}$/)) {
      //     zipCodeError = true;
      //     secondSectionError = true;
      //     message.error('کد پستی باید 10 رقم و عددی باشد')
      // } else {
      //     if (!zipCodeError) {
      //         this.setState({
      //             error: ''
      //         })
      //     }
      // }
      if (!secondSectionError) {
        const current = this.state.current + 1
        this.setState({current})
      }
    } else if (this.state.current == '2') {
      var {gender, email, phone, father, internalNumber} = this.state
      var phoneError = false
      var emailError = false
      var thirdSectionError = false

      if (
        email !== '' &&
        !email.match(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g
        )
      ) {
        thirdSectionError = true
        emailError = true
        message.error('ایمیل را صحیح وارد کنید')
      } else {
        if (!emailError) {
          this.setState({
            error: ''
          })
        }
      }

      if (phone !== '' && !phone.match(/[0-9]{8}/g)) {
        thirdSectionError = true
        phoneError = true
        message.error('تلفن را صحیح و 8 رقمی وارد کنید')
      } else {
        if (!phoneError) {
          this.setState({
            error: ''
          })
        }
      }
      if (!thirdSectionError) {
        const current = this.state.current + 1
        this.setState({current})
      }
    } else if (this.state.current == '3') {
      var {cityId, zipCode, address, birthday} = this.state
      var cityError = false
      var addressError = false
      var zipCodeError = false
      var forthSectionError = false

      if (cityId == '') {
        cityError = true
        forthSectionError = true
        message.error('شهر وارد کنید')
      } else {
        if (!cityError) {
          this.setState({
            error: ''
          })
        }
      }

      if (address == '') {
        addressError = true
        forthSectionError = true
        message.error('آدرس وارد کنید')
      } else {
        if (!addressError) {
          this.setState({
            error: ''
          })
        }
      }
      if (zipCode == '') {
        zipCodeError = true
        forthSectionError = true
        message.error('کد پستی وارد کنید')
      } else if (!zipCode.match(/^\d{10}$/)) {
        zipCodeError = true
        forthSectionError = true
        message.error('کد پستی باید 10 رقم و عددی باشد')
      } else {
        if (!zipCodeError) {
          this.setState({
            error: ''
          })
        }
      }
      if (!forthSectionError) {
        this.setState({
          error: ''
        })
      }
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  addUser = () => {
    let {birthday} = this.state
    var birthDayError = false
    var addError = false
    if (
      birthday !== '' &&
      !birthday.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/g
      )
    ) {
      birthDayError = true
      addError = true
      message.error('فرمت تولد صحیح وارد شود')
    } else {
      if (!birthDayError) {
      }
    }
    if (!addError) {
      var data = {
        roleCategory: this.state.roleCategory,
        roleIds: this.state.rolesArr,
        username: this.state.username,
        password: this.state.password,
        firstname: this.state.firstname,
        userCode: this.state.userCode,
        lastname: this.state.lastname,
        mobile: this.state.mobile,
        internalNumber: this.state.internalNumber,
        email: this.state.email === '' ? undefined : this.state.email,
        gender: this.state.gender,
        nationalId: this.state.nationalId,
        phone: this.state.phone === '' ? undefined : this.state.phone,
        father: this.state.father === '' ? undefined : this.state.father,
        birthday:
          this.state.birthday === ''
            ? undefined
            : this.convertDigit(jMoment(this.state.birthday, 'jYYYY/jMM/jDD').format('YYYY/MM/DD')),
        cityId: this.state.cityId,
        address: this.state.address,
        zipCode: this.state.zipCode
      }

      http
        .post(`${USER_MANAGE.USER_MANAGE_ADD_USER}`, data, {})
        .then((response) => {
          if (response.data.error == null) {
            message.success('کاربر با موفقیت اضافه شد.لطفا صبر کنید')
            if (this.state.roleCategory == '100') {
              setTimeout(() => {
                window.location.assign('/Drivers')
              }, 2000)
            } else {
              setTimeout(() => {
                window.location.assign('/Operators')
              }, 2000)
            }
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  prev() {
    const current = this.state.current - 1
    this.setState({current})
  }

  handleChange = (selectedOption) => {
    var wareCode = []
    this.setState({selectedOption})
    if (selectedOption.length == '0') {
      this.setState({
        rolesArr: []
      })
    } else {
      // alert(JSON.stringify(selectedOption))
      console.log(`Option selected:`, selectedOption)

      for (let prop of selectedOption) {
        wareCode.push(prop.id)
        this.setState({
          rolesArr: wareCode
        })
        sessionStorage.setItem('wareCode', JSON.stringify(wareCode))
      }
    }
  }

  changeRoleCat(e) {
    let target = e.target
    let value = target.value
    let name = target.name
    this.setState({
      [name]: value
    })

    this.setState({
      selectedOption: []
    })

    var category = document.getElementById('roleCategory').value
    var filterAccess = this.state.catArr
    http
      .get(`${SECURITY.SECURITY_MANAGE_LIST_ROLE}`, {})
      .then((response) => {
        if (response.data.errror == null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            roles: response.data.object
          })
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].id
            result[i]['label'] = result[i].title
          }

          filterAccess = []
          this.state.roles.forEach(function(item) {
            if (Number(category) === Number(item.category)) {
              filterAccess.push(item)
            }
          })

          this.setState({
            filterRoles: filterAccess
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  changeTextField(e) {
    let value = e.target.value
    let name = e.target.name
    this.setState({
      [name]: value
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  beforeMaskedValueChangeTo = (newState, oldState, userInput) => {
    var {value} = newState
    var selection = newState.selection
    var cursorPosition = selection ? selection.start : null

    // keep minus if entered by user
    if (value.endsWith('-') && userInput !== '-' && !this.state.value.endsWith('-')) {
      if (cursorPosition === value.length) {
        cursorPosition--
        selection = {start: cursorPosition, end: cursorPosition}
      }
      value = value.slice(0, -1)
    }

    return {
      value,
      selection
    }
  }

  submit(e) {
    e.preventDefault()
  }

  render() {
    const {selectedOption} = this.state
    const {current} = this.state

    let steps = [
      {
        title: 'مشخصات دسترسی',
        content: (
          <div className="accessInfoDiv">
            <div className="formComponent">
              <label>
                گروه نقش :<span className="requireFiled">*</span>
              </label>
              <select
                id="roleCategory"
                onChange={this.changeRoleCat.bind(this)}
                name="roleCategory"
                className="form-control"
              >
                <option value="">------</option>
                {this.state.cats.map((cat, index) => (
                  <option selected={this.state.roleCategory == cat.id ? true : false} value={cat.id}>
                    {cat.title}
                  </option>
                ))}
              </select>
            </div>

            <div className="formComponent">
              <label>
                نقش<span className="requireFiled">*</span>
              </label>
              <Select
                value={selectedOption}
                onChange={this.handleChange}
                options={this.state.filterRoles}
                isMulti={true}
                placeholder=""
              />
            </div>
            <div className="formComponent">
              <label>
                نام کاربری<span className="requireFiled">*</span>
              </label>
              <input
                type="text"
                value={this.state.username}
                autoComplete="off"
                onChange={this.changeTextField.bind(this)}
                className="form-control"
                id="username"
                name="username"
              />
            </div>

            <div className="formComponent">
              <label>
                کلمه عبور<span className="requireFiled">*</span>
              </label>
              <input
                type="password"
                value={this.state.password}
                autoComplete="off"
                onChange={this.changeTextField.bind(this)}
                className="form-control"
                id="password"
                name="password"
              />
            </div>
          </div>
        )
      },
      {
        title: 'مشخصات شخصی',
        content: (
          <div className="accessInfoDiv">
            <div className="formComponent">
              <label>
                نام <span className="requireFiled">*</span>
              </label>
              <input
                type="text"
                value={this.state.firstname}
                onChange={this.changeTextField.bind(this)}
                className="form-control"
                id="firstname"
                name="firstname"
              />
            </div>
            <div className="formComponent">
              <label>
                نام خانوادگی <span className="requireFiled">*</span>
              </label>
              <input
                type="text"
                value={this.state.lastname}
                onChange={this.changeTextField.bind(this)}
                className="form-control"
                id="lastname"
                name="lastname"
              />
            </div>
            <div className="formComponent">
              <label>
                موبایل<span className="requireFiled">*</span>
              </label>
              <input
                type="text"
                value={this.state.mobile}
                onChange={this.changeTextField.bind(this)}
                className="form-control"
                id="mobile"
                name="mobile"
              />
            </div>
            <div className="formComponent">
              <label>
                کد ملی<span className="requireFiled">*</span>
              </label>
              <input
                type="text"
                value={this.state.nationalId}
                onChange={this.changeTextField.bind(this)}
                maxLength="10"
                className="form-control"
                id="nationalId"
                name="nationalId"
              />
            </div>

            <div className="formComponent">
              <label>کد پرسنلی</label>
              <input
                type="text"
                value={this.state.userCode}
                onChange={this.changeTextField.bind(this)}
                className="form-control"
                id="userCode"
                name="userCode"
              />
            </div>
          </div>
        )
      },
      {
        title: 'مشخصات اختیاری',
        content: (
          <div className="accessInfoDiv">
            <div className="formComponent">
              <label>
                جنسیت<span className="requireFiled">*</span>
              </label>
              <select id="gender" className="form-control" onChange={this.changeTextField.bind(this)} name="gender">
                <option selected={this.state.gender == 'man' ? true : false} value="man">
                  مرد
                </option>
                <option selected={this.state.gender == 'woman' ? true : false} value="woman">
                  زن
                </option>
              </select>
            </div>
            <div className="formComponent">
              <label>ایمیل</label>
              <input
                type="email"
                value={this.state.email}
                className="form-control"
                onChange={this.changeTextField.bind(this)}
                id="email"
                name="email"
              />
            </div>
            <div className="formComponent">
              <label>تلفن </label>
              <input
                type="text"
                value={this.state.phone}
                className="form-control"
                onChange={this.changeTextField.bind(this)}
                id="phone"
                name="phone"
              />
            </div>
            <div className="formComponent">
              <label>شماره داخلی </label>
              <input
                type="number"
                value={this.state.internalNumber}
                className="form-control"
                onChange={this.changeTextField.bind(this)}
                id="internalNumber"
                name="internalNumber"
              />
            </div>
            <div className="formComponent">
              <label>نام پدر </label>
              <input
                type="text"
                value={this.state.father}
                onChange={this.changeTextField.bind(this)}
                className="form-control"
                id="father"
                name="father"
              />
            </div>
          </div>
        )
      },
      {
        title: 'مشخصات محل تولد',
        content: (
          <div className="accessInfoDiv">
            <div className="formComponent">
              <label>تولد </label>
              <InputMask
                autocomplete="off"
                id="birthday"
                name="birthday"
                placeholder="yyyy/mm/dd"
                className="form-control"
                mask="9999/99/99"
                maskChar={null}
                value={this.state.birthday}
                beforeMaskedValueChange={this.beforeMaskedValueChangeTo}
                onChange={this.changeTextField.bind(this)}
              />
            </div>
            <div className="formComponent">
              <label>
                شهر <span className="requireFiled">*</span>
              </label>
              <select id="cityId" onChange={this.changeTextField.bind(this)} className="form-control" name="cityId">
                <option value="">-------</option>
                {this.state.Cities.map((city, index) => (
                  <option selected={this.state.cityId == city.cityId ? true : false} value={city.cityId}>
                    {city.cityName}
                  </option>
                ))}
              </select>
            </div>
            <div className="formComponent">
              <label>
                آدرس <span className="requireFiled">*</span>
              </label>
              <input
                type="text"
                onChange={this.changeTextField.bind(this)}
                value={this.state.address}
                className="form-control"
                id="address"
                name="address"
              />
            </div>
            <div className="formComponent">
              <label>
                کد پستی <span className="requireFiled">*</span>
              </label>
              <input
                type="text"
                value={this.state.zipCode}
                maxLength="10"
                onChange={this.changeTextField.bind(this)}
                className="form-control"
                id="zipCode"
                name="zipCode"
              />
            </div>
          </div>
        )
      }
    ]

    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/Operators'}>کاربران</Link>
            </li>
            <li>افزودن کاربر</li>
          </ul>

          <div className="stepWrapper">
            <Steps current={current}>
              {steps.map((item, index) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
            <div className="steps-content">{steps[current].content}</div>
            <div className="steps-action">
              {current < steps.length - 1 && (
                <button className="confirmBtnModal" onClick={() => this.next()}>
                  مرحله بعد
                </button>
              )}
              {current === steps.length - 1 && (
                <button className="confirmBtnModal" onClick={() => this.addUser()}>
                  ثبت
                </button>
              )}
              {current > 0 && (
                <button className="cancelBtnModal" style={{marginRight: '10px'}} onClick={() => this.prev()}>
                  مرحله قبل
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AddUser
